import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CurrencyContext } from '../../utils/currencyContext';
import searchIcon from '../../assets/img/search-icon.png';
import './domainSearchForm.scss';

function DomainSearchForm() {
    const { i18n, t } = useTranslation();
    const [domain, setDomain] = useState('');
    const currentLanguage = i18n.language;
    const { currentCurrency } = useContext(CurrencyContext);
    const isFR = currentLanguage === 'fr';

    const getCurrencyCode = (currency) => {
        let currencyCode = 1;

        if (currency === 'usd') {
            currencyCode = 4;
        } else if (currency === 'gbp') {
            currencyCode = 5;
        }

        return currencyCode;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        // Construct the action URL with the search query
        const actionURL = `https://obambu.com/my/domainchecker.php?currency=${getCurrencyCode(currentCurrency)}&systpl=${currentLanguage}&language=${isFR ? 'french' : 'english'}&domain=${encodeURIComponent(domain)}`;

        // Redirect to the action URL
        window.location.href = actionURL;
    };

    return (
        <form className="domain-search" onSubmit={handleSubmit}>
            <div className="domain-checkup-left">
                <input
                    type="text"
                    className="domain-input"
                    name="domain"
                    placeholder={t('home-page.search-placeholder')}
                    pattern="^[a-zA-Z0-9.àéèç-]+$"
                    title={t('domain-page.search-title')}
                    value={domain}
                    onChange={(e) => setDomain(e.target.value)}
                />
            </div>
            <div className="domain-checkup-right">
                <button type="submit">
                    <img src={searchIcon} alt="Search icon" />
                    {t('buttons.search')}
                </button>
            </div>
        </form>
    );
}

export default DomainSearchForm;
